import { Text } from '@chakra-ui/react';
import { cardBrandLabel } from './card-brand-label';
import React from 'react';
import type { PaymentMethod as SharedPaymentMethod } from '@fluenceur/types';

interface PaymentMethodUsedProps {
  paymentMethod?: SharedPaymentMethod;
  fontWeight?: string;
  fontSize?: string | number;
}

const formatPaymentMethodText = (pm: SharedPaymentMethod): string => {
  if (pm.type === 'card' && pm.brand && pm.last4) {
    const brandName = cardBrandLabel(pm.brand);
    let baseText = `${brandName} •••• ${pm.last4}`;
    if (pm.expiryMonth && pm.expiryYear) {
      const month = pm.expiryMonth.toString().padStart(2, '0');
      const year = pm.expiryYear.toString().slice(-2);
      baseText += ` (expires ${month}/${year})`;
    }
    return baseText;
  } else if (pm.type === 'bank_transfer' && pm.last4) {
    return `Bank Transfer •••• ${pm.last4}`;
  }
  return 'Payment method';
};

export const PaymentMethodUsed: React.FC<PaymentMethodUsedProps> = ({
  paymentMethod,
  fontWeight = 'medium',
  fontSize = '15px',
}) => {
  if (!paymentMethod) {
    return (
      <Text fontSize={fontSize} fontWeight={fontWeight}>
        No payment method
      </Text>
    );
  }
  const displayText = formatPaymentMethodText(paymentMethod);
  return (
    <Text fontWeight={fontWeight} fontSize={fontSize}>
      {displayText}
    </Text>
  );
};

export default PaymentMethodUsed;
